import producer from "immer";
import { triggerAdjustEvent } from "../../..";
import { STEP } from "../../../shared/constants";

const INITIAL_STATE = {
	loading: false,
	authenticated: false,
	respError: false,
	newUsername: undefined,
	loadingSocialLogin: undefined,
	showModal: false,
	removeCache: true,
	loginFail: false,
	recaptchaError: false,
	dataPrepareLogin: null,
	credentialFlowStep: STEP.GO_TO,
};

export default function auth(state = INITIAL_STATE, action) {
	const ACTIONS = {
		"@auth/CHANGE_LOADING": (draft) => {
			draft.loading = action.payload.loading;
		},
		"@auth/AUTHENTICATE_REQUEST": (draft) => {
			draft.loading = true;
		},
		"@auth/AUTHENTICATE_PREPARE_LOGIN": (draft) => {
			draft.dataPrepareLogin = action.payload;
		},
		"@auth/TRACK_EVENT": (draft) => {
			const { id_investor } = action.payload;
			triggerAdjustEvent("nfulob", id_investor);
		},
		"@auth/SET_AUTHENTICATED": (draft) => {
			draft.authenticated = action.payload.authenticated;
		},
		"@auth/RESP_REQUEST_ERROR": (draft) => {
			draft.respError = action.payload.error;
		},
		"@auth/SET_NEW_USERNAME": (draft) => {
			draft.newUsername = action.payload.isValue;
		},
		"@auth/LOADING_SOCIAL_LOGIN": (draft) => {
			draft.loadingSocialLogin = action.payload.boo;
		},
		"@auth/SHOW_MODAL_SOCIAL_LOGIN": (draft) => {
			draft.showModal = action.payload.boo;
		},
		"@auth/REMOVE_CACHE_FOR_LOGIN": (draft) => {
			draft.removeCache = action.payload.param;
		},
		"@auth/SHOW_MESSAGE_LOGIN_FAIL": (draft) => {
			draft.loginFail = action.payload.param;
		},
		"@auth/SET_RECAPCTHA_ERROR": (draft) => {
			draft.recaptchaError = action.payload.param;
		},
		"@AUTH/CREDENTIAL_FLOW_STEP": (draft) => {
			draft.credentialFlowStep = action.payload.step;
		},
	};

	return producer(state, (draft) => {
		return Object.keys(ACTIONS).indexOf(action.type) !== -1 ? ACTIONS[action.type](draft) : state;
	});
}
